export const SB = {
  // ── Mock hover/pin rail geometry (design-mock `railStyle`) ──
  // Collapsed rail is a slim strip; hover/pin expands the panel over the canvas.
  rail: {
    collapsed: 58,   // px — collapsed rail width (mock 58px, was 52)
    circle: 36,      // px — workspace circle badge (Tailwind w-9)
    bar: 20,         // px — active accent-bar height (Tailwind h-5)
    pinBtn: 28,      // px — pin button hit box
  },
  icon: {
    chevronProject: 16,
    chevronSubject: 15,
    folder: 17,
    file: 16,
    actionAdd: 12,
    delete: 14,
    headerIcon: 18,
    headerAdd: 14,
    rowMenu: 14,
  },
  text: {
    primary: "text-[17px]",   // header / meta text
    project: "text-[16px]",
    subject: "text-sm",
    forge: "text-[14px]",
  },
  font: {
    sidebar: "font-sidebar",
    projectWeight: "font-medium",   // ← tweak project label weight here
  },
  row: {
    header: "px-3 py-3 gap-2",
    list: "px-1 py-2 space-y-1",    // ← VALID SYNTAX: space-y-N (hyphen, not plus). Scale: 1=4px 2=8px 3=12px 4=16px
    project: "px-2 py-0.5 gap-2",  // ← py-N controls project row height
    subject: "px-2 py-1.5 gap-2",  // ← py-N controls subject row height
    leaf: "px-3 py-1.5 gap-2",    // ← py-N controls forge row height
    projectSubjectGap: "mt-1",      // ← gap between project header and its subjects
    subjectGap: "space-y-0",        // ← gap between subject items
    subjectForgeGap: "mt-1",        // ← gap between subject header and its forges
    forgeGap: "space-y-0",          // ← gap between forge items
    indent: "pl-4",
    forgeIndent: "pl-6",
  },
  // Single source of truth for left-pane motion. One easing vocabulary shared by
  // the workspace drawer slide and the tree-panel collapse keeps the whole pane
  // feeling like one system. `ease` is the iOS/Vaul "smooth glide" curve
  // (fast-out, slow-in, no overshoot).
  motion: {
    ease: [0.32, 0.72, 0, 1] as [number, number, number, number],
    drawerDuration: 0.28,   // workspace drawer slide-in/out (seconds)
    panelDuration: 0.26,    // tree-panel expand/collapse (seconds)
    hoverCloseDelay: 260,   // ms grace before a hover-off closes the drawer
    hoverSuppress: 620,     // ms hover-reopen block after selecting (covers exit)
  },
} as const;
